<template>
    <div>
        <div class="sitemap-container">
            <section class="sitemap-title">
                <div class="page-container">
                    <h1 class="eyebrow-page omnes">
                        <span class="omnes">Site map</span>
                    </h1>
                </div>
            </section>

            <SitemapLinks />
        </div>
        <div class="blue-line"></div>
    </div>
</template>

<script>
import SitemapLinks from '../components/Sitemap-links.vue';

export default {
    components: {
        SitemapLinks,
    },
};
</script>
